import _regeneratorRuntime from "/var/jenkins_home/workspace/tingle.0974c021-198f-4724-af33-81ecc1444bfe/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

import getOAuthServerMetadata from '../../config/getOAuthServerMetadata';

var callTokenEndpoint = function callTokenEndpoint(authServerConfig, body) {
  return __awaiter(void 0, void 0, void 0,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee() {
    var _getOAuthServerMetada, tokenEndpoint, response;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _getOAuthServerMetada = getOAuthServerMetadata(authServerConfig), tokenEndpoint = _getOAuthServerMetada.tokenEndpoint;
            _context.next = 3;
            return fetch(tokenEndpoint, {
              method: 'POST',
              headers: {
                Accept: 'application/json'
              },
              body: body
            });

          case 3:
            response = _context.sent;
            _context.t0 = response.status;
            _context.next = _context.t0 === 200 ? 7 : _context.t0 === 400 ? 7 : _context.t0 === 503 ? 10 : _context.t0 === 429 ? 10 : 11;
            break;

          case 7:
            _context.next = 9;
            return response.json();

          case 9:
            return _context.abrupt("return", _context.sent);

          case 10:
            throw {
              error: 'unavailable',
              error_description: "".concat(tokenEndpoint, " returned ").concat(response.status)
            };

          case 11:
            throw {
              error: 'unknown_error',
              error_description: "".concat(tokenEndpoint, " returned ").concat(response.status)
            };

          case 12:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
};

export default callTokenEndpoint;